import { getUrlVars } from "../../utils";

export function getAuthParams() {
    let base_url;
    //let { redirect_uri, code_challenge, code_challenge_method } = getUrlVars(window.location.href);
    let { redirect_uri, code_challenge, code_challenge_method, scope } = getUrlVars(window.location.href);
    console.log("🔧 FRONTEND UTILS - Raw redirect_uri from URL:", redirect_uri);
    console.log("🔧 FRONTEND UTILS - All URL parameters:", getUrlVars(window.location.href));
    console.log("🔧 FRONTEND UTILS - Current window.location.href:", window.location.href);
    
    if (!redirect_uri) {
        console.error("🔧 FRONTEND UTILS - No redirect_uri found in URL parameters");
        window.location.href = "/startFrom"
    }
    if (redirect_uri) {
        redirect_uri = decodeURIComponent(redirect_uri);
        console.log("🔧 FRONTEND UTILS - Decoded redirect_uri:", redirect_uri);
        base_url = getBaseUrl(redirect_uri)
        console.log("🔧 FRONTEND UTILS - Extracted base_url:", base_url);
    }
    if (code_challenge) code_challenge = decodeURIComponent(code_challenge);
    if (code_challenge_method) code_challenge_method = decodeURIComponent(code_challenge_method);
    //return { base_url, redirect_uri, code_challenge, code_challenge_method }
    if (scope) scope = decodeURIComponent(scope);
    
    // Hardcode default scope if not present (from original AWS Cognito OAuth2 UI)
    if (!scope) scope = "aws.cognito.signin.user.admin+email+openid+phone+profile";
    
    const result = { base_url, redirect_uri, code_challenge, code_challenge_method, scope };
    console.log("🔧 FRONTEND UTILS - Final getAuthParams result:", result);
    return result;
    function getBaseUrl(redirect_uri) {
        var pathArray = redirect_uri.split( '/' );
        var protocol = pathArray[0];
        var host = pathArray[2];
        return protocol + '//' + host;
    }
}

export function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}